import * as fb from "@/firebase";
import * as fb_dbMethods from "@/services/fb_dbMethods";
import * as userSvc from "@/services/userSvc";
import * as entitySvc from "@/services/entitySvc";

import store from "@/store";
import api from "@/api";


export async function testFbFunc(opts) {
  const fbFuncsTestEndpt = `/api/test`;
  let res = await api.get(fbFuncsTestEndpt);
  return res.data;
}

export async function stripe_checkoutSessionCreateEdPt(opts) {
  let stripe_checkoutSessionCreateEdPt = "/api/stripe/checkoutSessionCreate";
  let res = await api.get(stripe_checkoutSessionCreateEdPt);
  return res.data;
}
